import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, ref } from 'vue';
import store from '@/store';
import { AxiosError } from 'axios';
import { generateApiKey as _generateApiKey, getApiKeys } from '@/api/user';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApiKeyInput',
  props: {
    allowRegenerate: { type: Boolean, default: true }
  },
  setup(__props: any) {



const apiKey: Ref<string | null> = ref('sampleapikey');
const loadingApiKey = ref(false);
const invalidPassword = ref(false);
const fatalError = ref(false);

const showPasswordPrompt = ref(false);
const passwordPromptMode: Ref<'show' | 'generate'> = ref('show');
const password = ref('');

const user = computed(() => {
    return store.state.user;
});

const inputType = computed(() => {
    return apiKey.value !== 'sampleapikey' ? 'text' : 'password';
});

const canShowApiKey = computed(() => {
    return apiKey.value === 'sampleapikey';
});

const handlePasswordSubmit = async () => {
    let success = false;
    if (passwordPromptMode.value === 'show') {
        success = await loadApiKey();
    } else if (passwordPromptMode.value == 'generate') {
        success = await generateApiKey();
    }

    if (success) {
        showPasswordPrompt.value = false;
    }
};

const showApiKey = () => {
    // Users impersonated from admin users do not need a password
    if (user.value?.ImpersonatedFromAdminUser) {
        password.value = '';
        loadApiKey();
    } else {
        promptPassword('show');
    }
};

const promptPassword = (mode: 'show' | 'generate') => {
    passwordPromptMode.value = mode;
    password.value = '';
    invalidPassword.value = false;
    showPasswordPrompt.value = true;
};

const generateApiKey = async (): Promise<boolean> => {
    let success = true;
    try {
        fatalError.value = false;
        loadingApiKey.value = true;
        const result = await _generateApiKey(password.value);
        apiKey.value = result.Key;
    } catch (error) {
        const axiosError = error as AxiosError;
        success = false;
        if (axiosError.response?.status === 400 && axiosError.response.data.Message) {
            if (axiosError.response.data.Message === 'Invalid Password') {
                invalidPassword.value = true;
            }
        } else {
            window.rumReportError(axiosError);
            fatalError.value = true;
        }
    } finally {
        loadingApiKey.value = false;
    }

    return success;
};

const loadApiKey = async (): Promise<boolean> => {
    let success = true;
    try {
        fatalError.value = false;
        loadingApiKey.value = true;
        const keys = await getApiKeys(password.value);
        apiKey.value = keys[0]?.Key || 'No API Key';
    } catch (error) {
        const axiosError = error as AxiosError;
        success = false;
        if (axiosError.response?.status === 400 && axiosError.response.data.Message) {
            if (axiosError.response.data.Message === 'Invalid Password') {
                invalidPassword.value = true;
            }
        } else {
            window.rumReportError(axiosError);
            fatalError.value = true;
        }
    } finally {
        loadingApiKey.value = false;
    }

    return success;
};

return { __sfc: true,apiKey, loadingApiKey, invalidPassword, fatalError, showPasswordPrompt, passwordPromptMode, password, user, inputType, canShowApiKey, handlePasswordSubmit, showApiKey, promptPassword, generateApiKey, loadApiKey, ValidationProvider, ValidationObserver, LoaderBtn }
}

})